import { DealViews } from "constants/deal";
import { AuthSuccessPayload } from "store/types";

import { IAction } from "../..";
import { RoleName } from "../../../constants";
import { AuthAction } from "../../actions";
import { initialState, IStore } from "../../store-context";
import { reducer } from "../index";

const rolesForHCSDashboard: RoleName[] = [RoleName.Admin, RoleName.Analyst, RoleName.Investor];
const myDealsPipelineRoles: RoleName[] = [RoleName.Admin, RoleName.Analyst, RoleName.Investor, RoleName.TeamViewer];

export const authSuccess = reducer.createHandler(
  AuthAction.SessionSuccess,
  (state: IStore, { payload }: IAction<AuthSuccessPayload>): IStore => {
    const { token, account, settings, opportunity_id, broadcast_token, default_bookmarks, urlQueryKeys, ...user } =
      payload;

    const {
      chartSnapshot,
      cubicBenchmark,
      cubicDashboard,
      cubicDealDashboard,
      cubicInvestorView,
      cubicDeal,
      cubicSnapshot,
      cubicCashflow,
      chartInvestorView,
      graphBenchmark,
      benchmark,
      benchmarkIndexName,
      cashflowId,
      dealsTableColumns,
      fileRepoColumns,
      correlationMatrix,
      investorFilter,
      snapshot,
      quickViewSystemCols,
      ...restUserSettings
    } = settings;

    return {
      ...state,
      userModule: {
        ...state.userModule,
        user: {
          ...state.userModule.user,
          ...user
        },
        account: {
          ...state.userModule.account,
          ...account
        },
        token,
        broadcast_token,
        // settings,
        opportunity_id,
        default_bookmarks,
        ...restUserSettings,
        fileRepoColumns: fileRepoColumns ?? {}
      },
      reports: {
        ...state.reports,
        // Don't set reports queries if they are in the URL
        ...(!urlQueryKeys.includes("reports") && {
          queries: {
            ...state.reports.queries,
            ...(investorFilter && investorFilter.length && { filters: { Investor: investorFilter } }),
            graphDataFormation: Object.entries(chartSnapshot).reduce((acc, [key, value]) => {
              return {
                ...acc,
                [key]: {
                  ...state.reports.queries.graphDataFormation[key],
                  ...value
                }
              };
            }, {}),
            cubicBenchmark,
            cubicDashboard,
            cubicDealDashboard,
            cubicDeal,
            cubicSnapshot,
            cubicCashflow,
            graphBenchmark,
            benchmarkTableColumns: benchmark,
            benchmarkIndexName,
            cashflowSetId: cashflowId,
            reportTableColumns: snapshot
          }
        }),
        // Don't set correlation matrix settings if they are in the URL
        ...(correlationMatrix &&
          !urlQueryKeys.includes("correlationMatrixSettings") && {
            correlationMatrixSettings: correlationMatrix
          }),
        ...(Array.isArray(quickViewSystemCols) &&
          quickViewSystemCols.length > 0 && {
            quickViewQueries: {
              ...state.reports.quickViewQueries,
              columns: {
                ...state.reports.quickViewQueries.columns,
                visibleSystemColumns: quickViewSystemCols
              }
            }
          })
      },

      // Set deal queries
      dealModule: {
        ...state.dealModule,
        queries: {
          ...state.dealModule.queries,
          tableColumns: dealsTableColumns,
          cubicInvestorView,
          chartInvestorView: Object.entries(chartInvestorView).reduce((acc, [key, value]) => {
            return {
              ...acc,
              [key]: {
                ...state.dealModule.queries.chartInvestorView[key],
                ...value
              }
            };
          }, {}),
          // Don't override deal view if deals query params are in the URL
          ...(!urlQueryKeys.includes("deals") && {
            // Set dashboard (investor view) if HCS - specific investor
            ...(account.show_hcs_view && {
              ...(investorFilter && investorFilter.length && { filters: { Investor: investorFilter } }),
              view: rolesForHCSDashboard.includes(payload.role.name as RoleName) ? DealViews.Dashboard : DealViews.GRID
            }),
            // Switch to grid if user has low priority and HCS not available
            ...(!account.show_hcs_view &&
              !myDealsPipelineRoles.includes(payload.role.name as RoleName) && {
                ...state.dealModule.queries,
                view: DealViews.GRID
              })
          })
        }
      }
    };
  }
);

reducer.createHandler(
  AuthAction.RemoveToken,
  (state: IStore): IStore => ({
    ...state,
    userModule: {
      ...state.userModule,
      token: ""
    }
  })
);

reducer.createHandler(AuthAction.Logout, (): IStore => {
  return initialState;
});
